const angular = require('angular');

angular.module('wowApp.common')
    .directive('wowEmailValidator', require('./email-validator.directive'));



// WEBPACK FOOTER //
// ./src/common/emailvalidator/index.js